<template>
  <div class="proposal-unified">
    <div class="modal-header-proposal">
      <div class="batch-header">
        <img
          :src="state.batch.cover_url"
          :alt="state.batch.title"
          class="batch-header-image"
        />

        <span class="batch-header-title">
      {{ state.batch.title }}
    </span>
      </div>

      <button class="delete" @click="closeModal" />
    </div>

    <div class="modal-body">
      <div class="content middle">
        <span class="title is-block has-text-weight-bold">
          Faça uma proposta!
        </span>
        <p class="description">
          Para avançar com esse lote, precisamos confirmar seus dados. Preencha
          o formulário abaixo para entrarmos em contato com você.
        </p>

        <div class="proposal-section">
          <div class="section-label proposal-section-label">Proposta</div>

          <div class="field">
            <AppInput
              v-money="state.proposalValue != '' ? money : null"
              type="tel"
              :value="state.proposalValue"
              placeholder="Digite o valor"
              label="Valor da proposta"
              :isSynchronized="true"
              @input="(value) => (state.proposalValue = value)"
              @change="(value) => unMaskMoney(value)"
            />
          </div>

          <div class="field">
            <label class="message-label">Condições de negociação</label>
            <textarea
              :value="state.proposalConditions"
              class="textarea"
              placeholder="Informe alguma condição que ajude na negociação deste lote. Ex: Pagamento à vista"
              @input="state.proposalConditions = $event.target.value"
            />
          </div>
        </div>

        <hr class="unified-divider" />

        <div class="section-label">Seus dados</div>

        <div class="field required-field">
          <AppInput
            type="text"
            :value="state.currentTrackedUser.name"
            placeholder="Digite seu nome"
            label="Nome"
            is-synchronized
            required
            @input="(value) => { state.currentTrackedUser.name = value }"
          />
        </div>

        <div class="field required-field">
          <AppInput
            type="email"
            :value="state.currentTrackedUser.email"
            placeholder="Digite seu e-mail"
            label="E-mail"
            is-synchronized
            required
            :error="errorEmail"
            message="E-mail inválido"
            :show-message="errorEmail"
            @input="(value) => { state.currentTrackedUser.email = value; isValidEmail(); }"
          />
        </div>

        <div class="required-field">
          <PhoneInput
            :value="state.currentTrackedUser.phone"
            label="Telefone"
            @input="(value) => { state.currentTrackedUser.phone = value }"
          />
        </div>

        <div class="field required-field">
          <AppInput
            v-mask="['###.###.###-##']"
            type="tel"
            :value="state.currentTrackedUser.cpf"
            placeholder="Digite seu CPF"
            label="CPF"
            is-synchronized
            required
            :error="errorCPF"
            message="CPF inválido"
            :show-message="errorCPF"
            @input="(value) => { state.currentTrackedUser.cpf = value }"
          />
        </div>

        <p class="has-text-weight-semibold is-size-7 has-text-grey">
          *Os eventos exigem verificação de documentos devido ao parcelamento
          oferecido. Mas não se preocupe, seus dados estão seguros e serão
          utilizados apenas para fins relacionados aos eventos.
        </p>

        <button
          class="button is-primary is-fullwidth"
          :disabled="state.isSubmitting || !canSubmit"
          :class="{ 'is-loading': state.isSubmitting }"
          @click="submit"
        >
          Registrar proposta
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AppInput from "components/ui/AppInput.vue";
import PhoneInput from "components/ui/PhoneInput.vue";
import AuctionRegistrationModalBatchCard from "./AuctionRegistrationModalBatchCard.vue";

import { VMoney } from "v-money";
import { mask } from "vue-the-mask";
import { computed } from "vue";
import { useToast } from "vue-toastification";

import {
  state,
  closeModal,
  createConversion,
  isValidCPF,
  errorCPF,
  isValidEmail,
  errorEmail,
} from "./auctionRegistrationModalContext";

export default {
  components: {
    AppInput,
    PhoneInput,
    AuctionRegistrationModalBatchCard,
  },
  directives: {
    money: VMoney,
    mask,
  },
  setup() {
    const toast = useToast();

    const money = {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false,
    };

    const unMaskMoney = (value) => {
      if (value.target.value === "R$ 0,00") {
        value.target.value = "";
      }
    };

    const canSubmit = computed(() => {
      const { name, email, phone } = state.currentTrackedUser;
      return !!(name && email && phone && isValidCPF() && isValidEmail());
    });

    const submit = () => {
      if (!state.auction) {
        toast.error("Não há dados do leilão disponíveis. Por favor, tente novamente.");
        return;
      }

      createConversion();
    };

    return {
      state,
      closeModal,
      money,
      unMaskMoney,
      errorCPF,
      isValidCPF,
      errorEmail,
      isValidEmail,
      canSubmit,
      submit,
    };
  },
};
</script>
